import { render, staticRenderFns } from "./PaybyBank.vue?vue&type=template&id=6c4c55dd&"
import script from "./PaybyBank.vue?vue&type=script&lang=js&"
export * from "./PaybyBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports